import React, { useEffect, useState } from 'react'
import { Flex, Box, Heading, Text } from 'rebass/styled-components'
import renderHTML from 'react-render-html'
import Breadcrumbs from '../modules/Breadcrumbs'
import Feed from '../modules/Feed'
import Featured from '../modules/Featured'
import Form from '../modules/Form'
import Characteristics from '../modules/Characteristics'

const ProductDetails = ({ data }) => {
    const [product, updateContent] = useState(false)

    useEffect(() => {
        updateContent(data)
    }, [data])

    return (
        <>
            {product && (
                <>
                    <Breadcrumbs
                        firstModule={true}
                        data={data}
                        options={{
                            bg: 'greyLight',
                        }}
                    />
                    <Featured
                        data={{
                            categories: product.categories,
                        }}
                        options={{
                            backgroundColor: 'greyLight',
                            media: product.media,
                            title: (
                                <Box
                                    as='span'
                                    color='aquaDark'
                                >
                                    {product.title}
                                </Box>
                            ),
                            subtitle: product.content.excerpt,
                            content: '',
                            carousel: true,
                        }}
                    />
                    <Box
                        pl='md'
                        pr='md'
                    >
                        <Flex
                            bg='white'
                            flexDirection={[
                                'column',
                                'column',
                                'column',
                                'row',
                                'row',
                                'row',
                                'row',
                            ]}
                            alignItems='flex-start'
                            justifyContent='space-between'
                            mt='sm'
                            mb='xxl'
                            variant='container'
                        >
                            <Box
                                flexBasis='50%'
                                flexGrow='1'
                                mr={['0', '0', '0', 'md', 'md', 'lg', 'lg']}
                            >
                                <Text
                                    as='p'
                                    fontSize='md'
                                    fontStyle='italic'
                                    variant='paragraph'
                                >
                                    {product.content.excerpt}
                                </Text>
                                <Heading
                                    as='h2'
                                    variant='h1'
                                >
                                    {product.title}
                                </Heading>
                                {renderHTML(product.content.description || '')}
                            </Box>
                            <Box
                                flexBasis='50%'
                                flexGrow='1'
                                ml={['0', '0', '0', 'md', 'md', 'lg', 'lg']}
                            >
                                <Characteristics data={product} />
                            </Box>
                        </Flex>
                    </Box>
                    <Form options={{ type: 'enquiry' }} />
                    <Feed
                        options={{
                            borderColor: 'black',
                            heading: 'Related vehicles',
                            spacing: {
                                bottom: 'lg',
                                left: 'md',
                                right: 'md',
                                top: 'lg',
                            },
                            type: 'carousel',
                            variation: 'filmstrip',
                        }}
                    />
                </>
            )}
        </>
    )
}
export default ProductDetails
